import { Marked, MarkedExtension, Parser, Token } from "marked";
import { markedSmartypants } from "marked-smartypants";

const renderer: MarkedExtension["renderer"] = {
  paragraph: parseTokens,
  heading: parseTokens,
  strong: parseTokens,
  em: parseTokens,
  blockquote: parseTokens,
  link: parseTokens,
  listitem: parseTokens,
  image: parseString,
  codespan: parseString,
  code: parseString,
};

function parseTokens (this: { parser: Parser }, {
  tokens,
}: { tokens: Array<Token> }) {
  return this.parser.parseInline(tokens);
}

function parseString ({
  text,
}: { text: string }) {
  return text;
}

function decodeHtml (input: string) {
  const doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

const marked = new Marked({
  renderer,
}, markedSmartypants());

export default function stripMarkdown (str?: string) {
  if (!str) return null;

  if (str.includes("\n")) {
    const parts = str.split(/(\n+)/);
    const parsed = parts.map((part, i) => {
      return i % 2 === 0 ? marked.parse(part) : part;
    });
    return parsed.join("");
  }

  return decodeHtml(marked.parse(str, {
    async: false,
  }));
}
